<div class="text-popup">
  <app-popup-top-line></app-popup-top-line>
  <div class="text-popup-header">
    <div class="title">{{ data.title }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>

  <div class="text-popup-body">
    <div>
      <div class="text-popup-body-raw-text-container">
        <div class="raw-text-field-value-container">
          <app-copy-button
            class="raw-text-field-copy-button"
            [successPopupPosition]="popupPosition.Left"
            [value]="data.text"
          ></app-copy-button>
          <pre class="raw-text-field-value" disabled="true">{{ data.text }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
